import { createBrowserRouter } from 'react-router-dom';
import Error from '../pages/error';
import Login from '../pages/login';
import Contents from '../pages/contents';
import AddContents from '../pages/add_contents';
import SendNotification from '../pages/send_notification';
import Price from '../pages/price';
import routes from './routes';
import ForgetPassword from '../pages/forget-password';
import EditContent from '../pages/edit_content';

const {
  LOGIN,
  ADD_CONTENTS,
  CONTENTS,
  PRICE,
  SEND_NOTIFICATION,
  FORGET_PASSWORD,
  CONTENT
} = routes;

const router = createBrowserRouter([
  {
    path: LOGIN,
    element: <Login />,
    errorElement: <Error />
  },
  {
    path: CONTENTS,
    element: <Contents />
  },
  {
    path: ADD_CONTENTS,
    element: <AddContents />
  },
  {
    path: SEND_NOTIFICATION,
    element: <SendNotification />
  },
  {
    path: PRICE,
    element: <Price />
  },
  {
    path: FORGET_PASSWORD,
    element: <ForgetPassword />
  },
  {
    path: CONTENT,
    element: <EditContent />
  }
]);

export default router;
